/**
 * 社員情報取得API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 社員情報
 */
export interface Sgkb992aResStaffInfoDto {
    /**
     * 社員コード
     */
    staffCode?: string;
    /**
     * 社員名
     */
    staffName?: string;
}

